import { FC } from "react";

import { fixedDigitsValue } from "helpers/dataHelpers";

import { FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";
import { CurrencyIcon } from "icons";

interface CheckBoxLabelProps {
  label: string;
  fiatPrice?: number;
  fmcPrice?: number;
}
export const CheckBoxLabel: FC<CheckBoxLabelProps> = ({
  label,
  fiatPrice,
  fmcPrice,
}) => {
  const hasPrice =
    typeof fiatPrice === "number" && typeof fmcPrice === "number";

  return (
    <FlexContainer $fullwidth $gap={4} $justify="space-between">
      <Typography.Title>{label}</Typography.Title>

      {hasPrice && (
        <FlexContainer $gap={4} $minWidth="160px" $justify="flex-end">
          <CurrencyIcon width="24" height="24" />

          <Typography.Title>
            {fixedDigitsValue(fmcPrice, 1)} | KD{" "}
            {fixedDigitsValue(fiatPrice, 3)}
          </Typography.Title>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};
